<template>
  <div>
    <h4>Content</h4>
    <quill-editor v-model="content" class="mt-2"></quill-editor> <!--:options="{theme: 'bubble'}" -->
    <h4>Content (alleen wanneer ingelogd)</h4>
    <quill-editor v-model="contentLoggedIn" class="mt-2"></quill-editor> <!--:options="{theme: 'bubble'}" -->
    <vs-button :disabled="loading" @click="saveContent()" color="success" class="mt-2">Opslaan</vs-button>
    <h4>Bestanden:</h4>
    <vs-upload class="mt-2" fileName="files[]" automatic :action="imageUploadUrl" :headers="uploadHeaders" @on-success="successUpload($event)"/>
    <div id="data-list-list-view" class="data-list-container">
      <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="uploads">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center">
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-danger" @click="deleteItems">
              <span class="ml-2 text-base text-danger">Delete</span>
            </div>
          </div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ uploads.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : uploads.length }} of {{ uploads.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="type">Naam</vs-th>
          <vs-th sort-key="url">Url</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.url }}</p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <vs-button :disabled="loading" @click="generateImages()" color="success" class="mt-2">Afbeeldingen hergenereren</vs-button>
  </div>
</template>
<script>
import api, {baseUrl} from '../../api';
import {mapState} from "vuex";
export default {
  name: 'Catalogus',
  components: {},
  props: {},
  data () {
    return {
      content: "",
      contentLoggedIn: "",
      loading: false,
      imageUploadUrl: baseUrl + 'admin/catalogus-uploads',
      uploads: [],
      itemsPerPage: 5,
      selected: [],
      currentPage: 1,
    }
  },
  computed: {
    ...mapState({
      authToken: state=>state.auth.token
    }),
    uploadHeaders(){
      return {
        Authorization: 'Bearer ' + this.authToken
      }
    }
  },
  mounted () {
    this.getSetting();
    this.getUploads();
  },
  methods: {
    getSetting(){
      this.loading = true;
      api.post("admin/settings", {keys: ['catalogus', 'catalogus-secure']}).then(response=>{
        this.content = response.data[0].value;
        this.contentLoggedIn = response.data[1].value;
        this.loading = false;
      }).catch((error)=>{
        console.log(error);
        this.loading = false;
      })
    },
    saveContent(){
      this.loading = true;
      const settings = {};
      settings['catalogus'] = this.content;
      settings['catalogus-secure'] = this.contentLoggedIn;
      api.put("admin/settings", {settings}).then(()=>{
        this.$vs.dialog({
          title: 'Gelukt!',
          text: 'Opslaan van de over ons pagina is gelukt',
          color: 'success'
        });
        this.loading = false;
      }).catch((error)=>{
        console.log(error);
        this.loading = false;
      })
    },
    getUploads(){
      api.get("admin/catalogus-uploads").then(response=>{
        console.log(response.data.data);
        this.uploads = response.data.data;
      }).catch((error)=>{
        console.log(error);
      })
    },
    generateImages() {
      api.get("admin/generate-images").then(()=>{
        this.$vs.dialog({
          title: 'Gelukt!',
          text: 'Het duurt even voordat de nieuwe afbeeldingen zijn geupload',
          color: 'success'
        });
      }).catch((error)=>{
        console.log(error);
      })
    },
    successUpload(e){
      let response = JSON.parse(e.target.responseText);
      console.log(response);
      this.getUploads();
    },
    deleteItems(){
      api.post("admin/catalogus-uploads/delete", {ids: this.selected.map(upload=>upload.id)}).then(()=>{
        this.getUploads();
      });
    }
  }
}

</script>
